import { Controller } from "stimulus"

export default class extends Controller {
  submit() {
      console.log('submit');
    const form = this.element.form || this.element.closest('form')
    if (!form) return
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit()
    } else {
      form.submit()
    }
  }
  connect(){
      console.log('connect');
  }
}

